import React from 'react';
import List from './styles';
import { Grid } from '@material-ui/core';
import ProgramCard from '../../../../../components/Cards/Program';
import { programModules } from '../../../../../utils';
import { useTranslation } from 'react-i18next';

const ProgramList = () => {
	const { t } = useTranslation();

	const getModules = () => {
		return programModules.map((module, key) => (
			<Grid item xs={12} sm={6} md={3} key={key}>
				<ProgramCard
					image={module.image}
					title={t(module.module)}
					description={t(module.title)}
					tag={t(module.tag)}
				/>
			</Grid>
		));
	};

	return (
		<List container spacing={2}>
			{getModules()}
		</List>
	);
};

export default ProgramList;
